import React from 'react';
import Shared from 'screens/shared';
import { actions } from 'redux/local';
import { _t, replaceObjectProps } from 'utils';
import { VALIDATION } from 'constant';

export default ({
  isCancel = false,
  onCancel,
  user: userEdit = {},
}) => {
  const { id, properties = {} } = userEdit;

  const user = {
    firstname: '',
    lastname: '',
    email: '',
    password: '',
    administrator: false,
    forceSecAuth: false,
  };

  const userFields = [
    {
      name: 'firstname',
      type: 'text',
      title: _t('First Name'),
    },
    {
      name: 'lastname',
      type: 'text',
      title: _t('Last Name'),
    },
    {
      name: 'email',
      type: 'text',
      title: _t('Email'),
    },
    {
      name: 'password',
      type: 'password',
      title: _t('Password'),
      visible: !id,
    },
    {
      name: 'administrator',
      type: 'switch',
      title: _t('Is Administrator?'),
    },
    {
      name: 'forceSecAuth',
      type: 'switch',
      title: _t('Force 2-Factor Auth?'),
    },
  ];

  const validations = [
    {
      name: 'firstname',
      type: VALIDATION.REQUIRED,
    },
    {
      name: 'firstname',
      type: VALIDATION.STRING,
      max: 63,
    },
    {
      name: 'lastname',
      type: VALIDATION.REQUIRED,
    },
    {
      name: 'lastname',
      type: VALIDATION.STRING,
      max: 63,
    },
    {
      name: 'email',
      type: VALIDATION.REQUIRED,
    },
    {
      name: 'email',
      type: VALIDATION.EMAIL,
    },
    {
      name: 'password',
      type: VALIDATION.REQUIRED,
    },
    {
      name: 'password',
      type: VALIDATION.STRING,
      min: 5,
    },
  ];

  const onSave = (values) => {
    if (id) {
      delete values.password;
      actions.user.update({ id, user: { properties: values } });
      onCancel();
    } else {
      actions.user.create({ user: { properties: values } });
    }
  };

  return (
    <>
      <Shared.forms.Form
        fields={userFields}
        fieldsValues={replaceObjectProps(user, properties)}
        onSubmit={onSave}
        isCancel={isCancel}
        onCancel={onCancel}
        validations={validations}
      />
    </>
  );
};
